export const states = [
    "punjab",
    "sindh",
    "balochistan",
    "khayber pakhtunkhwa",
    "gilgit baltistan",
];
export const cities = {
    "punjab": [
        "faisalabad",
        "lahore",
        "jhang",
        "gujranwala",
        "multan",
        "bahawalpur",
        "rawalpindi",
        "sargodha",
        "gujrat",
        "kasur",
        "rahim yar khan",
    ],
    "sindh": [
        "karachi",
        "hyderabad",
        "sukkar",
        "larkana",
        "nawabshah",
        "kotri",
        "mirpur khas",
        "shikarpur",
        "dadu",
        "umerkot",
    ],
    "balochistan": [
        "quetta",
        "turbat",
        "khuzdar",
        "hub",
        "chaman",
        "gwadar",
        "sibi",
        "loralai",
        "zhob",
        "mastung",
        "pasni",
        "qalat",
    ],
    "khayber pakhtunkhwa": [
        "peshawar",
        "mardan",
        "mingora",
        "kohat",
        "abbotabad",
        "dera ismail khan",
        "mansehra",
        "swabi",
        "nowshera",
        "charsadda",
        "bannu",
        "topi",
    ],
    "gilgit baltistan": [
        "skardu",
        "chilas",
        "jaglot",
        "khaplo",
        "shigar",
        "tolti",
        "karimabad",
        "danyor",
    ],
};
